
import { WorldCity } from '../types';

// Expansión de ciudades adicionales para Brasil (de 50 a 150 ciudades)
export const brazilAdditionalCities: WorldCity[] = [
  { name: 'Campinas', slug: 'campinas', population: 1213792 },
  { name: 'São Gonçalo', slug: 'sao-goncalo', population: 1084839 },
  { name: 'Maceió', slug: 'maceio', population: 1025360 },
  { name: 'Duque de Caxias', slug: 'duque-de-caxias', population: 924624 },
  { name: 'São Luís', slug: 'sao-luis', population: 1108975 },
  { name: 'Natal', slug: 'natal', population: 890480 },
  { name: 'Teresina', slug: 'teresina', population: 868075 },
  { name: 'Campo Grande', slug: 'campo-grande', population: 906092 },
  { name: 'Nova Iguaçu', slug: 'nova-iguacu', population: 821128 },
  { name: 'São Bernardo do Campo', slug: 'sao-bernardo-do-campo', population: 844483 },
  { name: 'João Pessoa', slug: 'joao-pessoa', population: 817511 },
  { name: 'Santo André', slug: 'santo-andre', population: 721368 },
  { name: 'Osasco', slug: 'osasco', population: 699944 },
  { name: 'Jaboatão dos Guararapes', slug: 'jaboatao-dos-guararapes', population: 706867 },
  { name: 'São José dos Campos', slug: 'sao-jose-dos-campos', population: 729737 },
  { name: 'Ribeirão Preto', slug: 'ribeirao-preto', population: 703293 },
  { name: 'Uberlândia', slug: 'uberlandia', population: 699097 },
  { name: 'Contagem', slug: 'contagem', population: 668949 },
  { name: 'Sorocaba', slug: 'sorocaba', population: 695328 },
  { name: 'Aracaju', slug: 'aracaju', population: 664908 },
  { name: 'Feira de Santana', slug: 'feira-de-santana', population: 619609 },
  { name: 'Cuiabá', slug: 'cuiaba', population: 650912 },
  { name: 'Joinville', slug: 'joinville', population: 597658 },
  { name: 'Juiz de Fora', slug: 'juiz-de-fora', population: 573285 },
  { name: 'Londrina', slug: 'londrina', population: 575377 },
  { name: 'Aparecida de Goiânia', slug: 'aparecida-de-goiania', population: 521002 },
  { name: 'Niterói', slug: 'niteroi', population: 515317 },
  { name: 'Belford Roxo', slug: 'belford-roxo', population: 510906 },
  { name: 'Caxias do Sul', slug: 'caxias-do-sul', population: 517451 },
  { name: 'Campos dos Goytacazes', slug: 'campos-dos-goytacazes', population: 507548 },
  { name: 'Ananindeua', slug: 'ananindeua', population: 535547 },
  { name: 'Florianópolis', slug: 'florianopolis', population: 508826 },
  { name: 'Vila Velha', slug: 'vila-velha', population: 501325 },
  { name: 'São João de Meriti', slug: 'sao-joao-de-meriti', population: 472906 },
  { name: 'Santos', slug: 'santos', population: 433656 },
  { name: 'Mauá', slug: 'maua', population: 477552 },
  { name: 'Diadema', slug: 'diadema', population: 426757 },
  { name: 'Carapicuíba', slug: 'carapicuiba', population: 400973 },
  { name: 'Mogi das Cruzes', slug: 'mogi-das-cruzes', population: 440769 },
  { name: 'Olinda', slug: 'olinda', population: 393115 },
  { name: 'Betim', slug: 'betim', population: 444784 },
  { name: 'Campina Grande', slug: 'campina-grande', population: 411807 },
  { name: 'Jundiaí', slug: 'jundiai', population: 423006 },
  { name: 'Piracicaba', slug: 'piracicaba', population: 407252 },
  { name: 'Cariacica', slug: 'cariacica', population: 383917 },
  { name: 'Bauru', slug: 'bauru', population: 379297 },
  { name: 'Montes Claros', slug: 'montes-claros', population: 413487 },
  { name: 'Anápolis', slug: 'anapolis', population: 391772 },
  { name: 'Canoas', slug: 'canoas', population: 348208 },
  { name: 'Petrópolis', slug: 'petropolis', population: 306678 },
  { name: 'Maringá', slug: 'maringa', population: 430157 },
  { name: 'Volta Redonda', slug: 'volta-redonda', population: 273988 },
  { name: 'Pelotas', slug: 'pelotas', population: 343651 },
  { name: 'Suzano', slug: 'suzano', population: 300559 },
  { name: 'Governador Valadares', slug: 'governador-valadares', population: 281046 },
  { name: 'Taubaté', slug: 'taubate', population: 317915 },
  { name: 'Guarujá', slug: 'guaruja', population: 322750 },
  { name: 'Caruaru', slug: 'caruaru', population: 361118 },
  { name: 'Blumenau', slug: 'blumenau', population: 361855 },
  { name: 'Imperatriz', slug: 'imperatriz', population: 259980 },
  { name: 'Santarém', slug: 'santarem', population: 306480 },
  { name: 'Mossoró', slug: 'mossoro', population: 300618 },
  { name: 'Rio Branco', slug: 'rio-branco', population: 413418 },
  { name: 'Uberaba', slug: 'uberaba', population: 340277 },
  { name: 'Presidente Prudente', slug: 'presidente-prudente', population: 230371 },
  { name: 'Novo Hamburgo', slug: 'novo-hamburgo', population: 249436 },
  { name: 'Franca', slug: 'franca', population: 358539 },
  { name: 'Vitória', slug: 'vitoria', population: 365855 },
  { name: 'Ponta Grossa', slug: 'ponta-grossa', population: 355336 },
  { name: 'São José do Rio Preto', slug: 'sao-jose-do-rio-preto', population: 460435 },
  { name: 'Foz do Iguaçu', slug: 'foz-do-iguacu', population: 258823 },
  { name: 'Paulista', slug: 'paulista', population: 331774 },
  { name: 'Limeira', slug: 'limeira', population: 308482 },
  { name: 'Cascavel', slug: 'cascavel', population: 332333 },
  { name: 'Santa Maria', slug: 'santa-maria', population: 283677 },
  { name: 'Guarulhos', slug: 'guarulhos', population: 1392121 },
  { name: 'Ribeirão das Neves', slug: 'ribeirao-das-neves', population: 334858 },
  { name: 'Praia Grande', slug: 'praia-grande', population: 330845 },
  { name: 'Petrópolis', slug: 'petropolis-rj', population: 306191 },
  { name: 'Itaquaquecetuba', slug: 'itaquaquecetuba', population: 365644 },
  { name: 'Francisco Morato', slug: 'francisco-morato', population: 171790 },
  { name: 'São Vicente', slug: 'sao-vicente', population: 365798 },
  { name: 'Cotia', slug: 'cotia', population: 253608 },
  { name: 'Taboão da Serra', slug: 'taboao-da-serra', population: 281000 },
  { name: 'Jacareí', slug: 'jacarei', population: 235416 },
  { name: 'Magé', slug: 'mage', population: 245071 },
  { name: 'Suzano', slug: 'suzano-sp', population: 300559 },
  { name: 'Itapevi', slug: 'itapevi', population: 245863 },
  { name: 'Barueri', slug: 'barueri', population: 276764 },
  { name: 'Embu das Artes', slug: 'embu-das-artes', population: 271028 },
  { name: 'Guaratinguetá', slug: 'guaratingueta', population: 123426 },
  { name: 'Sumaré', slug: 'sumare', population: 286211 },
  { name: 'São Caetano do Sul', slug: 'sao-caetano-do-sul', population: 161957 },
  { name: 'Franco da Rocha', slug: 'franco-da-rocha', population: 154068 },
  { name: 'Indaiatuba', slug: 'indaiatuba', population: 256223 },
  { name: 'Americana', slug: 'americana', population: 242018 },
  { name: 'Itapecerica da Serra', slug: 'itapecerica-da-serra', population: 175564 },
  { name: 'Rio Claro', slug: 'rio-claro', population: 208434 },
  { name: 'Araraquara', slug: 'araraquara', population: 238339 },
  { name: 'Itapetininga', slug: 'itapetininga', population: 165526 },
  { name: 'Atibaia', slug: 'atibaia', population: 146234 },
  { name: 'Salto', slug: 'salto', population: 120537 },
  { name: 'Cubatão', slug: 'cubatao', population: 131626 },
  { name: 'Araçatuba', slug: 'aracatuba', population: 198129 },
  { name: 'Hortolândia', slug: 'hortolandia', population: 234259 },
  { name: 'Marília', slug: 'marilia', population: 240590 },
  { name: 'São Carlos', slug: 'sao-carlos', population: 254484 },
  { name: 'Itu', slug: 'itu', population: 175568 }
];
